import { z } from 'zod';

/**
 * Loose shape-identification schema for pre-versioning grids. Validation is deliberately
 * minimal: the up() transform is defensive (asRecord/toNumber/toString) and the v0
 * validation after migration catches real corruption. NOTE: at the structure adapter,
 * `widgets` rows arrive denormalized (widget objects, not string ids).
 */
export const gridLegacySchema = z.looseObject({
    widgets: z.array(z.array(z.unknown())),
    id: z.unknown().optional(),
    tabId: z.unknown().optional(),
    columnId: z.unknown().optional(),
    data: z.unknown().optional(),
    variant: z.unknown().optional(),
});
